import {GlobalState} from "little-state-machine";

const updateAction = (state: GlobalState, payload: object) => ({
  ...state,
  ...payload
})

export default updateAction
